import AiAgentManualHistory from '../../../../../components/units/Management/AiAgent/Manual/History';

export default function AiAgentManualHistoryPage() {
  return <AiAgentManualHistory />;
}
